import React, { useState } from 'react';
import { Printer } from 'lucide-react';
import SpecialDataEntry from './special/SpecialDataEntry';
import SpecialReportModal from './special/SpecialReportModal';

/**
 * SpecialTestsPanel — top-level Special Tests surface.
 *
 * Rebuilt on 2026-02-18 to replace the flat CFField grid with a
 * three-section (TDT · SISI · ABLB) editor that includes
 * interactive graphs with two-way sync to the tables, auto
 * interpretation per section + overall, and a print-ready A4 report
 * matching the Audinexa reference asset.
 */
const SpecialTestsPanel = ({ data, onChange, patient, sessionId, audiologistName }) => {
  const [showReport, setShowReport] = useState(false);
  return (
    <div className="flex-1 flex flex-col min-h-0" data-testid="special-tab-root">
      <div className="flex items-center justify-between bg-slate-100 border-b border-slate-300 px-3 py-1 flex-shrink-0">
        <div className="text-xs font-semibold text-slate-700 uppercase">
          Audiometric Special Tests · TDT | SISI | ABLB
        </div>
        <button
          type="button"
          onClick={() => setShowReport(true)}
          data-testid="special-print-report-btn"
          className="inline-flex items-center gap-1 px-2.5 py-1 text-[11px] font-bold bg-slate-800 hover:bg-slate-900 text-white rounded shadow-sm"
          title="Preview + print the standalone Special Tests report (A4)"
        >
          <Printer size={12} /> Print Special Tests Report
        </button>
      </div>
      <SpecialDataEntry data={data} onChange={onChange} audiologistName={audiologistName} />
      {showReport && (
        <SpecialReportModal
          data={data}
          patient={patient}
          sessionId={sessionId}
          onClose={() => setShowReport(false)}
        />
      )}
    </div>
  );
};

export default SpecialTestsPanel;
